<template>
  <div class="mt-2 sm:mt-6 px-0 py-5 flex flex-col items-center justify-center relative">
    <!-- <spinner :busy="loading" color="#000" class="mt-12"></spinner> -->

    <!-- <div class="flex space-x-5">
      <button @click="test(0, 0, 0)" class="mt-4 mb-4">0.0</button>
      <button @click="test(0, 3, 4)" class="mt-4 mb-4">3.4</button>
      <button @click="test(0, 5, 5)" class="mt-4 mb-4">5.5</button>
      <button @click="test(0, 5, 7)" class="mt-4 mb-4">5.7</button>
      <button @click="test(1, 0, 0)" class="mt-4 mb-4">10</button>
    </div> -->

    <div class="h-fit flex items-center justify-center space-x-0">
      <vue-apex-charts v-if="hasData" class="w-full" type="bar" :options="options" :series="series"
        :animations="animations"></vue-apex-charts>
    </div>
  </div>
</template>

<script>
import Spinner from '@/Shared/Spinner';
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'LiveResultsBarChart',

  metaInfo() {
    return {
      title: `Live Results`,
    };
  },

  components: {
    Spinner,
    VueApexCharts,
  },

  props: ['session', 'translations'],

  data() {
    return {
      loading: false,
      options: {
        chart: {
          id: 'live-results-bar-chart',
          toolbar: {
            show: false,
          },
        },
        colors: ['#53c9ff'],
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
        xaxis: {
          categories: [],

          lines: {
            show: true,
          },

          axisBorder: {
            show: false,
          },
          labels: {
            show: true,
            style: {
              fontSize: '11px',
              fontWeight: 'normal'
            }
          },
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            borderRadiusApplication: 'end',
            horizontal: true,
          }
        },
      },
      series: [
        {
          name: 'Answers',
          data: [],
        },
      ],
      animations: {
        enabled: true,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: true,
          delay: 150
        },
        dynamicAnimation: {
          enabled: true,
          speed: 350
        }
      },
      refreshIntervalId: null,
      reloadQueued: false,
    };
  },

  mounted() {
    Echo.channel('markencode-app.session.' + this.session.id).listen(
      '.participant.answered',
      (e) => {
        this.load();
      }
    );

    this.load();

    this.refreshIntervalId = window.setInterval(() => {
      this.load();
    }, 10000);
  },

  destroyed() {
    if (this.refreshIntervalId) {
      clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  },

  methods: {
    load() {
      if (this.loading) {
        this.reloadQueued = true;
        return;
      }

      this.loading = true;
      this.reloadQueued = false;

      window.axios
        .post(
          this.route('live-results.answers', {
            uuid: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          this.convert(response.data.answers || {});
        })
        .catch((error) => {
          console.warn('live-results.bar.load failed', error?.response?.status, error?.message);
        })
        .finally(() => {
          this.loading = false;

          if (this.reloadQueued) {
            this.reloadQueued = false;
            this.load();
          }
        });
    },

    convert(answers) {
      const entries = this.normalizeEntries(answers);
      const categories = entries.map((entry) => entry[0]);
      const data = entries.map((entry) => entry[1]);

      this.options = {
        ...this.options,
        xaxis: {
          ...this.options.xaxis,
          categories,
        },
      };

      this.series = [
        {
          ...this.series[0],
          data,
        },
      ];
    },

    normalizeEntries(answers) {
      if (Array.isArray(answers)) {
        return answers
          .map((item, index) => {
            if (Array.isArray(item)) {
              return [String(item[0] ?? index), this.toCount(item[1])];
            }

            if (item && typeof item === 'object') {
              const label = item.name ?? item.label ?? item.text ?? index;
              const value = item.value ?? item.count ?? 0;
              return [String(label), this.toCount(value)];
            }

            return [String(index), this.toCount(item)];
          });
      }

      if (answers && typeof answers === 'object') {
        return Object.entries(answers).map(([key, value]) => [String(key), this.toCount(value)]);
      }

      return [];
    },

    toCount(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },

  },

  computed: {
    hasData() {
      return this.series[0]?.data?.length;
    },
  },
};
</script>
